// snackbar-service.ts
import {type BdkSnackbar} from '@breuni-ui/bdk-snackbar';

export function pushToSnackbar(title: string, img?: string, buttonText?: string, callbackFunction?: (id: string) => void, imageAltText?: string, disableTextMasking?: boolean) {
  const snackbar = document.querySelector('bdk-snackbar') as BdkSnackbar;

  if (!snackbar.shadowRoot) {
    console.error('bdk-snackbar element not found in the DOM or not ready.');
  }

  snackbar.show({
    text: title,
    content: img ? `<img src="${img}" alt="${imageAltText}" style="width: 100%; margin-top: 4px;">` : undefined,
    actionButtonText: buttonText,
    actionButtonAction: callbackFunction,
    closeButton: !!callbackFunction,
    showTimeIndicator: true,
    disableTextMasking: disableTextMasking,
  });
}
